export const LIST_POST = 'LIST_POST'
export const DETAIL_POST = 'DETAIL_POST'
export const TOTAL_POST = 'TOTAL_POST'
